<template>
  <session class="page-questions">
    <div class="questions-block">
      <div class="questions-block-l">
        <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ title }}</span>
        <span class="desc" v-html="Utils.presetHtmlText(desc)" />
        <div class="btnwrap" @click="Utils.toTargetPage('/contactus')"><Icon name="checkmore" size="48" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ btntext }}</span></div>
      </div>
      <div class="questions-block-r js-page-question">
        <div ref="pageFirstBlockRef" />
        <div class="item" :class="{ active: item?.question == listCurItem?.question }" v-for="(item, index) in list" :key="index" @click="listCurItemTab(item)">
          <div class="line" />
          <div class="question"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.question }}</span><Icon name="plus" size="24" /></div>
          <div class="answrap">
            <div class="answrap-i">
              <div class="ans"><span v-html="Utils.presetHtmlText(item?.ans)" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </session>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import * as Utils from '@/assets/utils';
  import Icon from '@/components/icon/index.vue';
  import Footer from '@/components/footer/index.vue';
  import { LOCAL, getLocalLangCode } from '@/assets/lang';
  import EventBus from '@/assets/eventbus';

  const pageFirstBlockRef = ref(null)

  const title = ref('');
  const desc = ref('');
  const btntext = ref('');
  const list = ref([]);
  const listCurItem = ref(null);
  const listCurItemTab = target => {
    if(target?.question == listCurItem.value?.question) {
      listCurItem.value = null
    }else{
      listCurItem.value = target;
    }
  }
  const init = () => {
    title.value = LOCAL('faq_faqs');
    desc.value = LOCAL('faq_faqs_desc');
    btntext.value = LOCAL('contact');
    list.value = LOCAL('faplist')
  }
  onMounted(() => {
    init();
    // listCurItemTab(list.value[0])
  })

  // 左侧回到顶部交互
  onMounted(() => {
    Utils.scrollToTop.register('js-page-question');
    EventBus.on('global_page_scroll_action_js-page-question', () => {
      pageFirstBlockRef.value.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" });
    });
  });
</script>

<style scoped lang="less">
  @import "index.less";
</style>
